import { Star } from 'lucide-react';
import type { PublicHolidayOverlay } from '@/hooks/usePublicHolidayOverlay';

interface PublicHolidayBadgeProps {
  holiday: PublicHolidayOverlay;
  /** Compact mode for week-view cells */
  compact?: boolean;
}

/**
 * Renders a public holiday indicator, visually distinct from leave overlays.
 * Uses a red/rose accent to differentiate from the amber leave badges.
 */
export function PublicHolidayBadge({ holiday, compact = false }: PublicHolidayBadgeProps) {
  if (compact) {
    return (
      <div className="text-[10px] px-1.5 py-0.5 rounded bg-rose-100 dark:bg-rose-900/40 text-rose-700 dark:text-rose-200 border border-rose-200 dark:border-rose-700 flex items-center gap-1 truncate">
        <Star className="h-2.5 w-2.5 flex-shrink-0 fill-current" />
        <span className="truncate">{holiday.name}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-rose-50 dark:bg-rose-900/20 border border-rose-200 dark:border-rose-800 text-rose-700 dark:text-rose-300 text-sm">
      <Star className="h-3.5 w-3.5 flex-shrink-0 fill-current" />
      <span className="font-medium">{holiday.name}</span>
    </div>
  );
}
